import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import notificationBarStore from '@client/stores/notificationBarStore';
import type { NotificationBarItem } from '@client/stores/notificationBarStore';

const NotificationBar = observer(
    ({ item, onClick }: { item: NotificationBarItem; onClick?: () => void }) => {
        return (
            <div
                className={twMerge('alert pointer-events-auto w-full cursor-pointer shadow-md')}
                style={{
                    transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    transform: item.visible ? 'translateY(0)' : 'translateY(-40px)',
                    opacity: item.visible ? 1 : 0,
                }}
                onClick={(e) => {
                    e.preventDefault();
                    onClick?.();
                }}
            >
                <div className="flex-1">
                    {item.title && (
                        <div className="mb-1 line-clamp-2 text-sm font-semibold">{item.title}</div>
                    )}
                    <div className="line-clamp-2 text-sm">{item.text}</div>
                </div>
            </div>
        );
    },
);

/**
 * 알림 바 컨테이너
 * - 루트에 한 번만 붙여둔다
 */
export const NotificationBarContainer = observer(() => {
    return (
        <div className="pointer-events-none fixed top-4 right-0 left-0 z-(--z-index-notification-bar)">
            <div
                className="mx-auto min-w-40"
                style={{
                    width: 'calc(100% - 40px)',
                    maxWidth: 'calc(var(--main-max-width) - 40px)',
                }}
            >
                <div className="stack w-full">
                    {_.map(_.reverse([...notificationBarStore.items]), (item) => (
                        <NotificationBar
                            key={item.id}
                            item={item}
                            onClick={
                                item.onClick
                                    ? () => notificationBarStore.handleClick(item.id)
                                    : undefined
                            }
                        />
                    ))}
                </div>
            </div>
        </div>
    );
});

export default NotificationBar;
